import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JdFormDirective } from './form.directive';
import { JdFormControlComponent } from './form-control.component';
import { JdFormLabelComponent } from './form-label.component';
import { JdFormExplainComponent } from './form-explain.component';
import { JdFormItemComponent } from './form-item.component';
import { JdFormExtraComponent } from './form-extra.component';
import { LabelTipDirective } from './label-tip.directive';

const EXPORT = [
  JdFormDirective,
  JdFormControlComponent,
  JdFormLabelComponent,
  JdFormExplainComponent,
  JdFormItemComponent,
  JdFormExtraComponent,
];

@NgModule({
  imports: [CommonModule],
  declarations: [...EXPORT, LabelTipDirective],
  exports: [...EXPORT]
})
export class JdFormModule {}
